import { render, staticRenderFns } from "./SpecialDay.vue?vue&type=template&id=2e1ae84b"
import script from "./SpecialDay.js?vue&type=script&lang=js&external"
export * from "./SpecialDay.js?vue&type=script&lang=js&external"
import style0 from "./SpecialDay.vue?vue&type=style&index=0&id=2e1ae84b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports